import { StorageSerializers, useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { autologin, validateToken } from '../services/auth'
import type { Permit, User } from '../definitions/auth'
import { computed } from 'vue'
import { setDatadogUser } from '@/services/datadog'

export const useAuthStore = defineStore('auth', () => {
  const user = useStorage<null | User>('vackUser', null, sessionStorage, {
    serializer: StorageSerializers.object
  })

  if (user.value) {
    setDatadogUser({
      id: String(user.value.id),
      name: user.value.full_name
    })
  }

  const isTeamLeader = computed(() => user.value?.is_team_leader ?? false)

  const userChatId = computed(() => user.value?.user_chat_id)

  const userTeamIds = computed(() => user.value?.team_leader_teams ?? [])

  const canDeleteRequest = computed(() => user.value?.can_delete_request ?? false)

  function setUserPermissions(permissions: Permit) {
    if (user.value) {
      user.value.permit = permissions
    }
  }

  async function signInWithAutologin({ token }: { token?: string }) {
    if (!token) return

    try {
      const response = await autologin({ token })
      const userInfo = response.data
      if (!userInfo) throw new Error('Error al loguearse')
      user.value = userInfo
      setDatadogUser({
        id: String(userInfo.id),
        name: userInfo.full_name
      })
    } catch (error) {
      console.log(error)
      throw new Error('Error al loguearse')
    }
  }

  async function validateUserSession() {
    try {
      const res = await validateToken()
      const { code: statusResponse } = res
      if (statusResponse === 'error') throw res.error
      return res.code
    } catch (error) {
      console.log(error)
    }
  }

  return {
    user,
    canDeleteRequest,
    userChatId,
    userTeamIds,
    isTeamLeader,
    signInWithAutologin,
    validateUserSession,
    setUserPermissions
  }
})
